// export const BASE_URL = "http://192.168.0.51:8000/"
export const BASE_URL =
  "https://uat.backend.vowstays.com/"; //Live;
  // "https://testing-uatbackend.vowstays.com/"; //TestLive
  // "https://backend.newvow.vowstays.com/"; //dev
  // "https://testing-backend.vowstays.com/";
  // "http://192.168.0.51:8000/";
  // "https://alla-nonretentive-transgressively.ngrok-free.dev/"; //local wrap ;
  // "https://carload-ungodly-plastic.ngrok-free.dev"; //local wrap ;

export const URLS = {
  LOGIN: "admin/login/",
  LOGOUT: "admin/logout/",
  REGISTER: "register-send-otp",
  RESEND_OTP: "resend-otp",
  REGISTER_OTP_VERIFY: "verify-otp-and-register",
  STATES: "states",
  FORGOT_PASSWORD: "admin/forget-password/",
  RESET_PASSWORD: "admin/reset-password/",
  ADMINURL: "master/admin/",
  SERVICESLIST: "master/service/",
  HOTELCATEGORIES: "master/category/",
  MASTERURL: "master/",
  MASTERLOCATION: "master/locations/",
  LOCATION: "locations/",
  PROPERTIES_DROPDOWN: "properties/",
  RECEPTION: "master/reception/",
  TIMESLOT: "master/timeslots/",
  MASTER_DROPDOWN_URL: "master/dropdown/",
  HOTELCATEGORIES_DROPDOWN: "categories/dropdown/",
  BANNERS: "master/banner/list/",
  BANNER_MASTER: "master/banner/",
  BANNER_ADD: "master/banner/home/",
  BANNER_AVAILABILITY: "master/banner/check-availability/",
  CHECKOUT_REVIEW: "master/complaint-review/admin-banner/",
  VIEW_CHECKOUT_REVIEW: "master/complaint-review-list/",
  CALENDAR_AVAILABILITY_LIST: "master/?type=51",
  CALENDAR_AVAILABILITY_ADD: "master/add/",
  CALENDAR_AVAILABILITY_EDIT: "master",

  // Tutorial vedios
  //Language
  LANGUAGE_CREATE: "master/language-create/",
  LANGUAGE_LIST: "master/language-list/",
  LANGUAGE_LIST_TABLE: "master/language-active-list/",
  LANGUAGE_EDIT: "master/language-edit/",
  LANGUAGE_DELETE: "master/language_delete/",

  //category
  VIDEO_CATEGORY_LIST: "master/video-category-list/",
  VIDEO_CATEGORY_POSITION: "master/category-position/",

  VIDEO_CATEGORY_CREATE: "master/video-category-create/",
  VIDEO_CATEGORY_EDIT: "master/video-category-edit/",
  VIDEO_CATEGORY_STATUS: "master/video-category-statusupdate/",
  VIDEO_CATEGORY_DELETE: "master/video-category-delete/",

  VIDEO_CATEGORY_GROUP_EDIT: "master/video-category-group-edit/",

  // Videos
  VIDEOS_LIST: "master/tutorial-videos-list/",
  VIDEOS_LIST_STATUS: "master/vow-video-status-update/",
  VIDEOS_LIST_DELETE: "master/delete-video/",
  VIDEO_CREATE: "master/upload-video-bunny-stream/",
  VIDEO_VIEW: "master/category-based-tutorial-videos/",
  VIDEO_STATUS: "master/single-video-status-update/",
  VIDEO_EDIT: "master/update-video/",
  VIDEO_DELETE: "master/delete-single-group-video/",

  //ROLES
  ROLE_LIST: "admin/roles/",
  ROLE_STATUS: "admin/role/update-status/",
  ROLE_PERMISSIONS_MODULE_LIST: "admin/modules/",
  ROLE_GROUP_PERMISSIONS_MODULE_LIST: "admin/grouped-modules/",
  ROLE_PERMISSIONS_LIST: "admin/permissions/",
  ADD_ROLE: "admin/role/",
  EDIT_ROLE: "admin/roles/",
  DELETE_ROLE: "/admin/roles/",

  // Owner
  OWNERS: "master/owners/",
  OWNER_DETAILS: "master/owner-details/add/",
  OWNERS_DROPDOWN: "master/owners/dropdown",

  //Receptionist
  RECEPTIONIST_LIST: "master/reception/list/",
  RECEPTIONIST_LIST_STATUS: "master/reception-owner/",
  RECPTIONIST_LIST_DELETE: "master/reception-owner/",
  RECEPTIONIST_OVERALL: "owner/receptionists/",

  //Users
  USERS_LIST: "master/profile/",
  USER_ACTIVE: "master/user/",
  USER_DELETE: "master/users/",
  USER_EXPORT_EXCEL: "master/user/excel-download/",

  //properties
  PROPERTIES_LIST: "master/properties/list/",
  PROPERTY_CITIES: "master/properties/cities/",
  PROPERTY_STATUS: "master/property/",
  PROPERTY_MASTER: "master/properties/",
  PROPERTY_IMAGE_DELETE: "master/property-images/delete/",
  PROPERTY_EDIT: "master/property/",
  OVERALL_PROPERTIES: "properties/",

  //MMC
  MMC_MASTER: "payment/master/plans/",
  CREATE_MMC: "payment/subscriptions/create/",
  VERIFY_MMC: "payment/subscriptions/verify/",
  MMC_TRANSACTIONS_LIST: "payment/master/properties/?status=",
  MMC_CANCELLATION_LIST: "payment/master/mmc-cancel-requests/?status=",
  MMC_CANCELLATION_APPROVAL: "payment/mmc/cancel-request/update/",
  MMC_TICKET_CREATE: "payment/mmc/tickets/create/",
  MMC_TICKET_LIST: "payment/mmc/tickets/list/",

  //Room booking
  MASTER_ROOM_BOOKING: "master/room-booking/",
  ADD_ROOM: "master/room-booking/add/",
  ROOMS_LIST: "master/room-booking/list/",
  ADD_HINTS: "master/hints/",
  //Property Room Price
  PROPERTY_SLOT_SPECIAL_DATES: "master/slot-special-date/list/",
  PROPERTY_ROOM_CREATE_MASTER: "master/property-room-price/",
  PROPERTY_ROOM_STATUS_MASTER: "master/property-room-price/status/",

  //Property special date price
  PROPERTY_SPECIAL_PRICE: "master/property-special-price/",

  //Block &  Un Block Rooms
  AVAILABLE_ROOM: "block/rooms-availability",
  BLOCK_METHOD: "block/block-rooms/",
  UNBLOCK_METHOD: "block/unblock-rooms/",
  ROOMS_BLOCK_LIST: "block/admin/properties-with-rooms/",
  ROOM_CATEGARYBLOCK_LIST: "block/availability/property/",

  //Propertes Block & Un Block Details
  AVAILABLE_PROPERTES_BLOCK: "block/properties/availability/dates/",
  PROPERTIES_BLOCK_METHOD: "block/block-property/",
  PROPERTIES_UNBLOCK_METHOD: "block/unblock-property/",
  PROPERTIES_BLOCK_LIST: "block/admin/properties/blocked/",

  //BLockDATE GET
  ALL_BLOCKDATE: "block/admin/property-blocked-dates/",
  PROPERTIES_DATE_BLOCK_ROOMS: "block/admin/blocked-dates/property-level/",
  // ALL_BLOCKDATE: "block/property-blocked-dates/",

  //Coupon
  GET_MULTIPLEUSER: "master/coupon/multiple/list/",
  GET_SINGLEUSER: "master/coupon/single/list/",
  USERLIST_DROPDOWN: "user/dropdown/",
  SERVICESLIST_DROPDOWN: "service/dropdown/",
  COUPON_DEACTIVES: "master/coupons/",
  COUPON_ADD: "master/coupon/add/",
  COUPON_UPDATEADD: "master/coupon/",
  COUPON_DELETE: "master/coupons/",
  COUPON_USER_DROPDOWN: "master/coupons/dropdown/",
  //Refer List
  REFERLIST: "master/referral/list",
  REFERUSERHISTORY: "master/referral/details/",

  //BOOKINGS
  BOOKING_LIST: "block/admin/bookings/history/",
  BOOKED_ROOMS: "block/booking-summary/",
  BOOKED_ROOM_VIEW: "block/bookings/by-date/",
  BOOKED_PROPERTY_DETAILS: "block/bookings/details/",
  CANCEL_BOOKING: "block/admin/cancel-booking/",
  HOLD_BOOKING: "block/admin/hold-booking/",
  RELEASE_BOOKING: "block/admin/release-booking/",
  CHECK_IN: "block/booking/check-in/",
  CHECK_OUT: "block/booking/check-out/",
  USER_TRANSACTION: "block/user/transaction/list/",
  //DOWNLOAD EXCEL
  DOWNLOAD_EXCEL: "block/admin/bookings/excel/",

  //TRANSACTIONS
  TRANSACTIONS: "block/admin/transaction/list/",
  TRANSACTIONS_CANCEL_REJECT: "block/admin/hotel-request/reject/",
  TRANSACTIONS_CANCEL_ACCEPT: "block/admin/hotel-request/accept/",

  // Wallet USER
  USER_WALLET_LIST: "master/user_wallet/list/",
  USER_WALLET_ADD: "master/user_wallet/add/",
  USER_WALLET_ACCEPT: "master/user_wallet/accept/",
  USER_WALLET_BOOKING: "master/user_wallet/dropdown/",
  USER_WALLET_REJECT: "master/user_wallet/reject/",
  USER_WALLET_RESEND: "master/user_wallet/resend/",
  USER_WALLET_EDIT: "master/user_wallet/edit/",

  // Waller Owner
  OWNER_WALLET_LIST: "master/owner_wallet/list/",
  OWNER_WALLET_ADD: "master/owner_wallet/add/",
  OWNER_WALLET_ACCEPT: "master/owner_wallet/accept/",
  OWNER_WALLET_REJECT: "master/owner_wallet/reject/",
  OWNER_WALLET_RESEND: "master/owner_wallet/resend/",
  OWNER_WALLET_DROPDOWNLIST: "master/owner_wallet/dropdown/",
  OWNER_WALLET_UPDATE: "master/owner_wallet/dropdown/",
  OWNER_WALLET_EDIT: "master/owner_wallet/edit/",
  OWNER_WALLET_FAILED: "master/owner_wallet/failed/",
  OWNER_WALLET_FAILED_REASON: "master/owner_wallet/failed/add/",
  OWNER_REPAY_SEND: "master/owner_wallet/repay/",
  //Notification
  ABSENT_LIST: "block/admin/booking/absent-list/",
  ABSENT_REASON: "block/admin/manage-booking/",
  REJECTLISTVIEW: "master/wallet_transaction/",
  SEND_NOTIFICATIONS: "master/users/notifications/send/",

  //REVIEW
  REVIEW_LIST: "user/reviews/list/",
  REVIEW_STATUS: "user/review/update-status/",
  REVIEW_FILTERS: "user/reviews/filter-options/",

  //WISHLIST
  WISHLIST: "user/wishlist/properties/",
  WISHLIST_VIEW: "user/wishlist/property/",

  //NOTIFY ME
  NOTIFYME: "user/notify-me/properties/",
  NOTIFYME_VIEW: "user/notify-me/properties/",

  OWNERSDELETEUSER: "master/deleted-owners/",
  USERDELETEUSER: "master/deleted-users/",

  // OWNER PAYOUT LIST
  OWNER_PAYOUTLIST: "master/payout_list/",
  OWNER_PAYOUT_ACCEPT: "master/payout/accept/",
  OWNER_PAYOUT_FAILED: "master/payout/fail/",
  OWNER_OVERALL_PROPERTYTRANSACTION: "block/property-transactions/",
  // Dashboard List
  DASHBOARTOP_CARD: "master/dashboard/top-cards/",
  DASHBOARALL_CARD: "master/dashboard/all-card/",
  DASHBOARBLOCKED_CARD: "master/dashboard/blocked-card/",
  DASHBOARBOOKING_CARD: "master/dashboard/bookings-card/",
  DASHBOARMMC_CARD: "master/dashboard/mmc-card/",
  DASHBOARPROFIT_CARD: "master/dashboard/profit-card/",
  DASHBOARREVENUE_CARD: "master/dashboard/revenue-card/",

  //Vow settings
  VOW_VERSION_LIST: "master/settings/list/",
  VOW_VERSION_UPDATE: "master/settings/",

  MAINTANENCE_CREATE: "master/settings/",

  //flag
  PROPERTY_BLUE_FLAG_LIST: "master/properties/blue-flag/",
  PROPERTY_RED_FLAG_LIST: "master/properties/red-flag/",
  PROPERTY_FLAG_COUNT_DETAIL: "master/properties/cancelled-booking-summary/",
  USERNOTIFICATION_LIST: "master/users/filter/?page_size=50",
  USERNOTIFICATION_ADD: "master/users/notifications/",
  USERNOTIFICATION_DATA: "master/users/notifications/list/",

  NOTIFICATION_COUNTREDUCE: "master/notifications/mark-as-read/",
  WHATSAPPSUPPORT: "master/whatsapp/",
  AUDIT_LOG: "master/audit-logs/",
  FORCELOGOUT: "master/force-logout-all/",
  VERIFY_OTP: "admin/login/verify-otp/",
  INVOICE_USER: "/master/gst-invoice-list/",
  INVOICE_USER_DOWNLOAD: "/master/gst-invoice-excel/",
  EXCEL_DOWNLOAD_NOTIFICATION: "/block/notification/excel/download/",
  NOTIFICATION_LOCATION_CITIES_BY_STATES: "master/locations/cities-by-states/",

  PAYMENT_FAILED_TRANSACTION: "block/user/failed-transactions/",
  USER_FAILED_TRANSACTION: "block/user/failed-transactions/",
  USER_FAILED_TRANSACTION_DETAILS: "block/user/failed-transactions/details/",
  USER_FAILED_TRANSACTION_MARKREAD: "block/failed-transactions/mark-read/",
  NOTIFICATION_SEND_DELETE: "master/admin-user-notification/",

  //PAYMENT GATEWAY
  PAYMENT_FAILED_LIST: "block/payment-gateway/failure-alerts/",
  PAYMENT_FAILED_MARK_AS_READ:
    "block/payment-gateway/failure-alerts/mark-read/",
  CANCEL_MMC: "payment/admin/mmc/cancel/",

  //VOW BUNDLE UPDATES

  VOW_BUNDLE_CREATE: "master/settings/create/",

  //SOS ALERTS
  SOS_ALERTS_LIST: "master/sos-requests/",
  SOS_ALERTS_RESPOND: "master/admin-sos-response/",
  FIREBASE_ACTIVE: "master/settings/firebase-notification/",
  CHAT_BOTGET: "master/chat-bot-status-list/",
  CHAT_BOTUPDATE: "master/chat-bot-status-update/",
  CHAT_AI_LIST: "master/chat-ai-list/",
  BOOKING_AI_LIST: "master/booking-ai/",
  CHAT_AI_LIST_UPDATE: "master/chat-status-update-api/",
  AI_AREA_LIST: "master/user-chat-improvement-list/",
  AI_AREA_COMMENT: "master/user-chat-improvement-status-update/",

  AI_NOTIFICATION: "/master/ai/token-limit-notification/",
  AI_NOTIFICATION_UPDATE: "/master/notifications/mark-as-read/",
};
export const RZP_KEY = "rzp_live_yelgAnQUfUU1pv"; //Live Key
// export const RZP_KEY = "rzp_test_RXBsAwYtN6KmFB"; //TEST Razory Pay KJey
